import { Component, OnInit } from '@angular/core';
import { FiltersAbstractService } from '../../../../common-page-components/classes/filters-abstract-service';
import { HttpClient } from '@angular/common/http';
import { CategoryCombo, TextFilter, HistoricalComboAthlete } from '../../../../common-page-components/stores/filters-store/filters-store';
import { combineLatest } from 'rxjs';
import { MembersAthletesFiltersServiceService } from '../services/members-athletes-filters-service.service';

@Component({
  selector: 'app-bootstrap-members-athletes-filters',
  templateUrl: './bootstrap-members-athletes-filters.component.html',
  styleUrls: ['./bootstrap-members-athletes-filters.component.scss']
})
export class MembersAthletesFiltersComponent {

  constructor(public filter_service: MembersAthletesFiltersServiceService) {
  }


}
